<script>
import { Bar } from "vue-chartjs";
import Vue from "vue";

export default Vue.extend({
  name: "BarChart",
  extends: Bar,
  props: {
    data: { type: Object, default: undefined },
    options: { type: Object, default: undefined },
  },
  watch: {
    data: {
      handler: function () {
        this.renderChart(this.data, this.options);
      },
    },
    immediate: true,
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
});
</script>
